import React from 'react';
import Translate from '../../components/Translate';

export var getKycType = function getKycType(type) {
  var translations = {
    ID: React.createElement(Translate, { id: 'label.kyc-type-id', defaultMessage: 'ID' }),
    CreditCard: React.createElement(Translate, { id: 'label.kyc-type-creditcard', defaultMessage: 'Credit card' }),
    ProofOfAddress: React.createElement(Translate, {
      id: 'label.kyc-type-proofofaddress',
      defaultMessage: 'Proof of address'
    }),
    BankStatement: React.createElement(Translate, {
      id: 'label.kyc-type-bankstatement',
      defaultMessage: 'Bank statement'
    }),
    EWallet: React.createElement(Translate, { id: 'label.kyc-type-wallet', defaultMessage: 'E-wallet' }),
    SourceOfWealth: React.createElement(Translate, {
      id: 'label.kyc-type-sourceofwealth',
      defaultMessage: 'Source of wealth'
    }),
    Other: React.createElement(Translate, { id: 'label.kyc-type-other', defaultMessage: 'Other' })
  };

  return translations[type] || type;
};